(function () {
	'use strict';

	angular
		.module('app.setup')
		.service('manageCacheService', manageCacheService);

	function manageCacheService($http, $rootScope, URLS) {
		return {
			refreshCache: refreshCache
		};

		function refreshCache(factoryNdxs, cacheObjectTypes) {
			var url = '/api/2/factndx/' + globalConfig.factory.id + '/UpdateCache?' +
					'objectTypes=' + cacheObjectTypes + '&factoryNdxs=' + factoryNdxs;
			return $http.post(url)
				.then(refreshCacheComplete)
				.catch(refreshCacheFailed);

			function refreshCacheComplete(response) {
				return response;
			}

			function refreshCacheFailed(response) {
				return response;
			}
		}
	}
})();
